import { render, staticRenderFns } from "./EducationalQualificationAdd.vue?vue&type=template&id=ccb8735c"
import script from "./EducationalQualificationAdd.vue?vue&type=script&lang=ts"
export * from "./EducationalQualificationAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports